// Supabase client. Public (RLS-gated) keys, sourced from build-time env
// vars so we can point preview/staging builds at a different project
// without a code change. Required GitHub Actions secrets are documented
// in `.github/workflows/deploy.yml` and `.env.example`.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY. ' +
      'Set them in your local `.env` (see `.env.example`) and in the ' +
      'GitHub Actions repository secrets used by the deploy workflow.'
  );
}

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'sb-zbdgjhhhnlfgsxwxavcj-auth-token',
    flowType: 'pkce',
  },
});
